import React from 'react';
import {
    Show,
    TextField,
    BooleanField,
    SimpleShowLayout
} from 'react-admin';

// own ui
import CustomImageField from '../../ui/custom-image-field';

const ThemeShow = props => (
    <Show
      title="Tema" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <CustomImageField source="image_thumb" label="Imagem Thumb" sortable={false}/>
            <CustomImageField source="image_cover" label="Imagem Cover" sortable={false}/>
            <TextField source="name.pt_br" label="Nome PT-BR" sortable={false} />
            <TextField source="name.en_us" label="Nome EN-US" sortable={false} />
            <TextField source="title.pt_br" label="Título PT-BR" sortable={false} />
            <TextField source="title.en_us" label="Título EN-US" sortable={false} />
            <TextField source="description.pt_br" label="Descrição PT-BR" sortable={false} />
            <TextField source="description.en_us" label="Descrição EN-US" sortable={false} />
            <BooleanField source="active" label="Ativo" sortable={false} />
        </SimpleShowLayout>
    </Show>
);

export default ThemeShow;
